export function inlineVideo() {
    const inlineVideo = $(".inline-video");

    inlineVideo.on("click", ".play-btn", function () {
        const $parent = $(this).parents(".inline-video");
        const currentVideo = $parent.find("video")[0];

        if(currentVideo) {
            $parent.addClass("video-play");
            currentVideo.play();
            return false;
        }

    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/inline-video.js